<!-- 传给子组件的signals bill 在子组件mount组件初始化，如果无法正确获取，需要通过watch方法追踪第一次初始化  -->
<template>
    <div class="billContainer d-flex flex-column">
        
        <div class="queryPage flex-grow-1 flex-shrink-1 pa-0 ma-0 " v-show="queryPageVisible">
            <div class="d-flex flex-column" style="width:100%;height:100%">
                <div class="queryButtonPane pa-0 ma-0  flex-grow-0 flex-shrink-0 ">
                    <component :is="getQueryButtonPaneComponent()"  class="queryButtonPaneComponent  pa-0 ma-0" ref="queryButtonPane"
                        :context="getContext()"
                    >
                    </component>
                </div>
                
                <div class="line"/>                

                <div class="queryConditionPane pa-0 ma-0  flex-grow-0 flex-shrink-0 " v-show="queryConditionVisible">
                    <component :is="getQueryConditionPaneComponent()"  class="queryConditionPaneComponent  pa-0 ma-0" ref="queryConditionPane"
                        :context="getContext()"
                    >
                    </component>
                </div>
                <div class="queryResultPane pa-0 ma-0  flex-grow-1 flex-shrink-1 " style="position:relative;">
                    <!-- div class="resultPaneWrapper pa-0 ma-0" -->
                        <component :is="getQueryResultPaneComponent()"  class="queryResultPaneComponent  pa-0 ma-0" ref="queryResultPane"
                            :context="getContext()"
                        >
                        </component>
                    <!-- /div -->
                </div>
            </div>
        </div>
        
        <div class="editPage flex-grow-1 flex-shrink-1 pa-0 ma-0" v-show="editPageVisible">
            <div class="d-flex flex-column" style="width:100%;height:100%">
                <div class="editorButtonPane pa-0 ma-0  flex-grow-0 flex-shrink-0 ">
                    <component :is="getEditorButtonPaneComponent()"  class="editorButtonPaneComponent  pa-0 ma-0" ref="editorButtonPane"
                        :context="getContext()"
                    >
                    </component>
                </div>

                <div class="line"/>
                
                <div class="editorPane pa-0 ma-0  flex-grow-1 flex-shrink-1 d-flex ">
                    <component :is="getEditorPaneComponent()"  class="editorPaneComponent  pa-0 ma-0 flex-grow-1 flex-shrink-1" ref="editorPane"
                        :context="getContext()" :editorComponent="getEditorComponent()"
                    >
                    </component>
                </div>
                <div class="operaterInfoPane pa-0 ma-0  flex-grow-0 flex-shrink-0 ">
                    <component :is="getOperatorInfoPaneComponent()"  class="operatorInfoPaneComponent  pa-0 ma-0" ref="operatorInfoPane"
                        :context="getContext()"                >
                    </component>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import DefaultQueryButtonPaneComponent from './QueryButtonPane.vue';
    import DefaultQueryConditionPaneComponent from './QueryConditionPane.vue';
    import DefaultQueryResultPaneComponent from './QueryResultPane.vue';
    import DefaultEditorButtonPaneComponent from './EditorButtonPane.vue';
    import DefaultEditorPaneComponent from './EditorPane.vue';
    import DefaultEditorComponent from './Editor.vue';
    import DefaultOperatorInfoPaneComponent from './OperatorInfoPane.vue';

    import ModeHelper from './ModeHelper.js';
    import Mode from './Mode.js';

    import MessageDialogHelper from './MessageDialogHelper.js';

    import JsonUtil from "../../../util/JsonUtil.js";
    import { Signal } from "@robotlegsjs/signals";

    export default {
        name:'Bill',
        data () {
            return {
                name:'Bill',

               
                //1 查询页 2 编辑页
                bShowPage:1,
                bShowQueryCondition:true,

                modeHelper:new ModeHelper(this),
                messageDialogHelper:new MessageDialogHelper(this),

                //关键字字段名，空表单关键字段值
                itemKeyName:'billId',
                emptyKeyValue:-1,
                emptyData:null,

                signals:{
                    //查询条件面板点击查询，且通过校验，应传输所有选择的条件;由查询结果面板侦听并执行加载第一页数据
                    loadQueryResultAsked:new Signal(),
                    //请求浏览单据，双击查询结果进入浏览单据状态,如果没有传入单据数据，则显示为一个空白编辑器
                    browseBillAsked:new Signal(),
                    //点击了编辑按钮
                    editBillAsked:new Signal(),
                    //查询结果表格选择了一行数据，考虑取消此消息，通过在BILL维护当前选中行数据，查询界面按钮组通过此数据作出响应
                    browseBillSelected:new Signal(),
                    //查询条件面板可见性发生变化
                    queryConditionVisiblityChangeAsked: new Signal(),
                    //查询结果导出请求
                    exportQueryResultAsked:new Signal(),
                    //点击了新增单据
                    newBillAsked:new Signal(),
                    //点击了删除单据
                    deleteBillAsked:new Signal(),
                    //点击了保存单据
                    saveBillAsked:new Signal(),
                    //点击了停用
                    stopAsked:new Signal(),
                    //点击了启用
                    restoreAsked:new Signal(),
                    //点击了审核单据
                    auditBillAsked:new Signal(),
                    //点击了反审核单据
                    cancelAuditASked:new Signal(),
                    //点击了上架
                    putOnAsked:new Signal(),
                    //点击了下架
                    widthDrawAsked:new Signal(),
                    //点击了作废
                    voidBillAsked:new Signal(),
                    //点击了取消作废
                    cancelVoidAsked:new Signal(),
                    //点击了编辑取消
                    editCancelAsked:new Signal(),
                    //编辑界面点击了返回
                    editBackAsked:new Signal(),

                    //点击了导出详情
                    exportDetailAsked:new Signal(),
                    
                    //其他自定义请求,根据内部载体数据处理,如果要根据数据状态判断按钮是否可用,最好通过计算属性来实现
                    customCommandAsked: new Signal(),
                },
                billComponents:{
                    bQueryButtonPaneComponent:this.queryButtonPaneComponent,
                    bQueryConditionPaneComponent:this.queryConditionPaneComponent,
                    bQueryResultPaneComponent:this.queryResultPaneComponent,
                    bEditorButtonPaneComponent:this.editorButtonPaneComponent,
                    bEditorPaneComponent:this.editorPaneComponent,
                    bOperatorInfoPaneComponent:this.operatorInfoPaneComponent,
                    bEditorComponent:this.editorComponent,
                }
            }
        },
        
        props:{
            
            //查询面板-按钮面板
            queryButtonPaneComponent:Object,
            //查询面板-查询条件面板
            queryConditionPaneComponent:Object,
            //查询面板-结果面板
            queryResultPaneComponent:Object,
            //编辑面板-按钮面板
            editorButtonPaneComponent:Object,
            //编辑面板-表单编辑器
            editorPaneComponent:Object,
            //编辑面板-操作员信息面板
            operatorInfoPaneComponent:Object,
            //菜单编号
            menuId:String,
            //查询结果工作者
            queryResultWorker:Object,
            //编辑器
            editorComponent:Object,
            //关键字信息{itemKeyName:'',emptyKeyValue:-1}
            queryResultKeyInfo:Object,
            //点击新增后产生的空记录
            emptyRec:Object,
        },
        
        components:{
            'DefaultQueryButtonPaneComponent':DefaultQueryButtonPaneComponent,
            'DefaultQueryConditionPaneComponent':DefaultQueryConditionPaneComponent,
            'DefaultQueryResultPaneComponent':DefaultQueryResultPaneComponent,
            'DefaultEditorButtonPaneComponent':DefaultEditorButtonPaneComponent,
            'DefaultEditorPaneComponent':DefaultEditorPaneComponent,
            'DefaultOperatorInfoPaneComponent':DefaultOperatorInfoPaneComponent,
            'DefaultEditorComponent':DefaultEditorComponent,
        },
        methods:{
            getBill(){
                return this;
            },
            getSignals(){
                return {};
            },
            getModeHelper(){
                return this.modeHelper;
            },
            getPermissionHelper(){
                return this.permissionHelper;
            },
            getMenuId(){
                return this.menuId;
            },
            getQueryResultKeyName(){
                if(this.queryResultKeyInfo && this.queryResultKeyInfo.itemKeyName)
                    return this.queryResultKeyInfo.itemKeyName;
                return this.itemKeyName;    
            },
            getEmptyKeyValue(){
                if(this.queryResultKeyInfo && this.queryResultKeyInfo.emptyItemKeyValue)
                    return this.queryResultKeyInfo.emptyItemKeyValue;
                return this.emptyItemKeyValue;
            },
            getEmptyData(){
                if(!this.emptyData){
                    let empty = this.emptyRec?this.emptyRec:null;
                    if(!empty){
                        empty = {};
                        empty[this.getQueryResultKeyName()] = this.getEmptyKeyValue();
                    }
                    this.emptyData = empty;
                }
                let empty ={};
                Object.assign(empty,this.emptyData);
                return empty;
            },
            isEmptyData(billData){
                let emptyData = this.getEmptyData();
                /*
                for(var idx in emptyData){
                    let v1 = emptyData[idx];
                    let v2 = billData[idx];
                    if(!(v1==v2)){
                        return false;
                    }
                }
                */
                return JsonUtil.diff(emptyData,billData);
            },
            showQueryPage(){
                this.bShowPage=1;
            },
            showEditPage(){
                this.bShowPage=2;
            },
            switchShowQueryCondition(){
                this.showQueryCondition(!this.getShowQueryCondition());
            },
            showQueryCondition(ifShow){
                if(ifShow)
                    this.bShowQueryCondition=true;
                else
                    this.bShowQueryCondition=false;
            },
            getShowQueryCondition(){
                return this.bShowQueryCondition;
            },
            getQueryButtonPaneComponent(){
                if(this.queryButtonPaneComponent)
                    return this.queryButtonPaneComponent;
                return this.getDefaultQueryButtonPaneComponent();
            },
            getQueryConditionPaneComponent(){
                if(this.queryConditionPaneComponent)
                    return this.queryConditionPaneComponent;
                return this.getDefaultQueryConditionPaneComponent();
            },
            getQueryResultPaneComponent(){
                if(this.queryResultPaneComponent)
                    return this.queryResultPaneComponent;
                return this.getDefaultQueryResultPaneComponent();
            },
            getEditorButtonPaneComponent(){
                if(this.editorButtonPaneComponent)
                    return this.editorButtonPaneComponent;
                return this.getDefaultEditorButtonPaneComponent();
            },
            getEditorPaneComponent(){
                if(this.editorPaneComponent)
                    return this.editorPaneComponent;
                return this.getDefaultEditorPaneComponent();
            },
            getEditorComponent(){
                if(this.editorComponent)
                    return this.editorComponent;
                return this.getDefaultEditorComponent();
            },
            getOperatorInfoPaneComponent(){
                if(this.operatorInfoPaneComponent)
                    return this.operatorInfoPaneComponent;
                return this.getDefaultOperatorInfoPaneComponent();
            },
            getDefaultQueryButtonPaneComponent(){
                return DefaultQueryButtonPaneComponent;
            },
            getDefaultQueryConditionPaneComponent(){
                return DefaultQueryConditionPaneComponent;
            },
            getDefaultQueryResultPaneComponent(){
                return DefaultQueryResultPaneComponent;
            },
            getDefaultEditorButtonPaneComponent(){
                return DefaultEditorButtonPaneComponent;
            },
            getDefaultEditorPaneComponent(){
                return DefaultEditorPaneComponent;
            },
            getDefaultEditorComponent(){
                return DefaultEditorComponent;
            },
            getDefaultOperatorInfoPaneComponent(){
                return DefaultOperatorInfoPaneComponent;
            },
            getQueryButtonPane(){
                return this.$refs.queryButtonPane;
            },
            getQueryConditionPane(){
                return this.$refs.queryConditionPane;
            },
            getQueryResultPane(){
                return this.$refs.queryResultPane;
            },
            getEditorButtonPane(){
                return this.$refs.editorButtonPane;
            },
            getEditorPane(){
                return this.$refs.editorPane;
            },
            getOperatorInfoPane(){
                return this.$refs.operatorInfoPane;
            },
            getContext(){
                let me = this;
                return {
                    bill:me,
                    signals:me.signals,
                    modeHelper:me.modeHelper,
                    messageDialogHelper:me.messageDialogHelper,
                    queryResultWorker:me.queryResultWorker,
                };
            },
            //注入表单和信号集合到子元素
            injectContext(){
                let me = this;
                let context = this.getContext();

                let queryButtonPane = this.getQueryButtonPane();
                let queryConditionPane = this.getQueryConditionPane();
                let queryResultPane = this.getQueryResultPane();
                let editorButtonPane = this.getEditorButtonPane();
                let editorPane = this.getEditorPane();
                let operatorInfoPane = this.getOperatorInfoPane();
               
                if(queryButtonPane && queryButtonPane.injectContext){
                    queryButtonPane.injectContext(context);
                }

                if(queryConditionPane && queryConditionPane.injectContext){
                    queryConditionPane.injectContext(context);
                }

                if(queryResultPane && queryResultPane.injectContext){
                    queryResultPane.injectContext(context);
                }

                if(editorButtonPane && editorButtonPane.injectContext){
                    editorButtonPane.injectContext(context);
                }

                if(editorPane && editorPane.injectContext){
                    editorPane.injectContext(context);
                }

                if(operatorInfoPane && operatorInfoPane.injectContext){
                    operatorInfoPane.injectContext(context);
                }
            },
            initSignals(){
                let me = this;
                if(!this.signalInited){
                    this.signals.queryConditionVisiblityChangeAsked.add(function(){
                        me.switchShowQueryCondition();
                    });
                    this.signals.newBillAsked.add(function(){
                        me.showEditPage();
                    });
                    this.signals.editBackAsked.add(function(){
                        me.showQueryPage();
                    });
                    this.signals.browseBillAsked.add(function(){
                        me.showEditPage();
                    });
                    this.signalInited = true;
                }
            },
            //获取查询结果页中，表格已经选中的记录,上面按钮组浏览按钮根据此记录是否存在，决定按钮是否可用
            getQueryPaneFirstSelectedRecord(){
                if((this.getQueryResultPane())
                &&(this.getQueryResultPane().getFirstSelectedRecord))
                    return this.getQueryResultPane().getFirstSelectedRecord();
                return null;
            },

            
        },
        
        computed:{
            queryPageVisible(){
                return this.bShowPage==1;
            },
            editPageVisible(){
                return this.bShowPage==2;
            },
            queryConditionVisible(){
                return this.bShowQueryCondition && 
                this.modeHelper &&
                this.modeHelper.getQueryButtonExists();
            }
        },
        created(){
            console.log("bill created");
            console.log(this.menuId);
            this.modeHelper.loadBillSupportedAction();
            this.initSignals();
        },
        mounted(){
            //通过属性传输，不再通过方法注入
            console.log("bill mounted");
        }
    }
</script>

<style scoped>
    .billContainer{
        padding:0px;
		margin: 0px;
		width:100%;
		height:100%;
    }

    .queryPage{
        padding:0px;
		margin: 0px;
		width:100%;
		height:100%;
    }

    .resultPaneWrapper{
        position:absolute;
        left:0px;
        top:0px;
        bottom:0px;
        right:0px;
        overflow:scroll;
    }

    

    .editPage{
        padding:0px;
		margin: 0px;
		width:100%;
		height:100%;
    }

    .line{
        border-bottom:1px dashed lightgrey;
    }
</style>
